import { Box, Typography } from "@mui/material";
import capitalize from "lodash/capitalize";

import { useInsightsContext } from "../context";
import InsightThreeDotMenu from "./InsightThreeDotMenu";

export const InsightStatus: React.FC = () => {
  const { selectedInsight } = useInsightsContext();

  const isCustomInsight = selectedInsight?.providerId === "custom";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            color: "text.secondary",
          }}
        >
          Status
        </Typography>
        <Typography variant="h3" sx={{ mb: 1 }}>
          {capitalize(selectedInsight?.userStatusChanges?.status ?? "actionable")}
        </Typography>
      </Box>
      <InsightThreeDotMenu
        existingPriority={selectedInsight?.priority ?? null}
        existingTags={selectedInsight?.tags ?? null}
        existingExpertNote={selectedInsight?.expertNote?.note ?? null}
        isCustomInsight={isCustomInsight}
      />
    </Box>
  );
};
